<template>
  <div class="w-full p-4">
    <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
      <button
        type="button"
        class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        @click="close">
        <span class="sr-only">Close</span>
        <!-- Heroicon name: outline/x -->
        <svg
          class="h-6 w-6"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <div class="sm:flex sm:items-start">
      <div class="mt-3 text-center sm:mt-0 sm:text-left">
        <h3 class="text-lg font-medium leading-6 text-gray-900">
          Write a new note about your client
        </h3>
        <p class="mt-2 text-sm text-gray-800">
          Here you can update status on your client or add any notes on your dialogue with them.
        </p>
      </div>
    </div>
    <div class="my-4 flex w-full flex-col space-y-4">
      <div>
        <label
          for="type"
          class="mb-1 block text-sm font-medium text-gray-700">Type of activity</label>
        <SelectMenuCustomWithAvatar
          v-model="selectedElement"
          :elements="elements"
          :selected-element="selectedElement"
          class="z-50 w-60" />
      </div>
      <div>
        <label
          for="comment"
          class="mb-1 block text-sm font-medium text-gray-700">Write your comment about the activity</label>
        <textarea
          id="comment"
          v-model="form.comment"
          name="comment"
          rows="6"
          class="block w-full max-w-lg rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" />
      </div>
    </div>
    <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
      <button
        type="button"
        class="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
        @click="save">
        Add
      </button>
      <button
        type="button"
        class="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm"
        @click="close">
        Cancel
      </button>
    </div>
  </div>
</template>
<script>

import SelectMenuCustomWithAvatar from '@/Components/Selectors/SelectMenuCustomWithAvatar.vue';
import { ref } from 'vue';

import {
  DocumentTextIcon, PhoneIcon, EnvelopeIcon, CalendarDaysIcon, QuestionMarkCircleIcon,
} from '@heroicons/vue/24/solid';

export default {
  components: { SelectMenuCustomWithAvatar },
  props: {
    client: Object,
    project: Object,
  },

  data() {
    return {
      team_members: [],
      form: this.$inertia.form({
        type: '',
        activable_type: this.client?.class ?? this.project?.class,
        activable_id: this.client?.id ?? this.project?.id,
        comment: '',
      }),

      selectedElement: {},
    };
  },

  computed: {
    elements() {
      return [
        {
          id: 0,
          type: 'note',
          title: 'General note',
          icon: DocumentTextIcon,
        },
        {
          id: 1,
          type: 'call',
          title: 'Phone Call',
          icon: PhoneIcon,
        },
        {
          id: 2,
          type: 'email',
          title: 'Email',
          icon: EnvelopeIcon,
        },
        {
          id: 3,
          type: 'meeting',
          title: 'Meeting',
          icon: CalendarDaysIcon,
        },
        {
          id: 6,
          type: 'other',
          title: 'Other type of activity',
          icon: QuestionMarkCircleIcon,
        },
      ];
    },
  },

  watch: {
    selectedElement: {
      handler() {
        this.form.type = this.selectedElement.type;
      },

      deep: true,
    },
  },

  mounted() {
    this.selectedElement = this.elements[0] ?? {};
  },

  methods: {
    close() {
      this.$emit('close');
    },

    save() {
      this.form.post(route('activity.store'), {
        errorBag: 'storeActivity',
        preserveScroll: true,
      });
      this.close();
    },

    reset() {
      this.form.errors = {};
    },
  },
};
</script>
